import { useQuery } from '@tanstack/react-query'
import { getConversation } from '../../../data/statsAssistant'
import { UserFriendlyError } from '../../../model/Error'
import { statsAssistantKeys } from './statsAssistant.keys'

interface UseConversationParams {
  ulid: string | null
  enabled?: boolean
}

/** Partagé avec la resynchronisation Centrifugo, qui recharge des conversations hors composant. */
export const fetchConversation = async (ulid: string) => {
  const { data, ok } = await getConversation(ulid)
  if (!data || !ok) {
    throw new UserFriendlyError(
      'error',
      'Impossible de charger la conversation',
      'Une erreur technique s’est produite',
    )
  }
  return data
}

export const useConversation = ({ ulid, enabled = true }: UseConversationParams) =>
  useQuery({
    queryKey: statsAssistantKeys.conversation(ulid ?? ''),
    queryFn: () => {
      if (!ulid) throw new Error('ULID de conversation requis')
      return fetchConversation(ulid)
    },
    enabled: enabled && ulid !== null,
    staleTime: 5_000,
    refetchOnWindowFocus: false,
    // Garde le fil précédent uniquement d'une conversation vers une autre.
    // ulid=null (Nouvelle analyse) ne doit pas réafficher l'ancien chat.
    placeholderData: (previous) => (ulid ? previous : undefined),
  })
